















































































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import Paging from 'biz-ts/src/api/Paging';
import MqttEventWrapper from "@/model/MqttEventWrapper";
import {Container} from "typescript-ioc";
import Pagination from '@/component/Pagination/index.vue'
import RealtimeRefresh from "@/component/Switch/realtime-refresh.vue";
import PaginationTable from "@/component/Table/pagination-table.vue";
import VueJsonPretty from 'vue-json-pretty';
import InfoDialog from "@/component/Dialog/info-dialog.vue";
import {mqttEventTypeZh} from "@/module/mqtt/MqttEvent";
import DeviceApi from "@/module/device/DeviceApi";
import {mqttClientTypeZh} from "@/module/mqtt/MqttClientType";
import deviceModule from "@/store/module/DeviceModule";
import DeviceMqttEventWrapper, {findTmpl} from "@/model/DeviceMqttEventWrapper";
import DeviceMqttApi from "@/module/device/DeviceMqttApi";
import {DmqttEventPqForm} from '@/form/DeviceMqttForm';
import DeviceMqttEventApi from "@/module/device/DeviceMqttEventApi";
import ThingModelApi from "@/module/thing/ThingModelApi";
import InstrTmpl from "@/module/instr/InstrTmpl";
import ArrayUtil from "tools-ts/src/util/ArrayUtil";
import InstrTmplItem from "@/component/Thing/instr-tmpl-item.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import {datePickerOptions} from '@/component/DatePicker';

@Component({
  components: {
    InstrTmplItem,
    Pagination,
    RealtimeRefresh,
    PaginationTable,
    VueJsonPretty,
    InfoDialog,
    RefreshButton,
  }
})
export default class DeviceMqttEventView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private dmqttApi = Container.get(DeviceMqttApi)

  private dmqttEventApi = Container.get(DeviceMqttEventApi)

  @Ref()
  private ptable!: PaginationTable

  @Ref()
  private jsonDialog!: InfoDialog

  private get device() {
    return deviceModule.active
  }

  private mqttEventWrapper?: MqttEventWrapper = undefined

  private get mqttEvent() {
    if (this.mqttEventWrapper)
      return JSON.parse(this.mqttEventWrapper.eventJson)
    else return undefined
  }

  private paging = new Paging<MqttEventWrapper>()
  private pqForm = new DmqttEventPqForm(this.device.id)

  private eventTypeZh = mqttEventTypeZh
  private clientTypeZh = mqttClientTypeZh

  private pickerOptions = datePickerOptions

  private tmodelApi = Container.get(ThingModelApi)

  private instrTmplsMap = new Map<number, InstrTmpl>()

  private async created() {
    await this.getPaging()
    const instrTmpls = await this.tmodelApi.instrTmpls(this.device.product.id)
    this.instrTmplsMap = ArrayUtil.groupById(instrTmpls, (tmpl) => {
      return tmpl.funId
    })
  }

  private async getPaging() {
    return this.dmqttEventApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }

  private funFmt(wrapper: DeviceMqttEventWrapper): string {
    const tmpl = this.findTmpl(wrapper)
    if (!tmpl) return ''
    return `${tmpl.funId} - ${tmpl.name}`
  }

  private findTmpl(wrapper: DeviceMqttEventWrapper) {
    return findTmpl(wrapper, this.instrTmplsMap)
  }

  private handleDetailClick(wrapper: DeviceMqttEventWrapper) {
    this.mqttEventWrapper = wrapper.mqttEventWrapper
    this.jsonDialog.open()
  }
}
